<template>
  <v-row>
    <v-col cols="12">
      <v-expansion-panels focusable>
        <v-expansion-panel v-for="(lead, i) in leads" :key="'lead-' + i" style="cursor:pointer;">
          <v-expansion-panel-header class="py-0">
            <v-row class="pa-0 align-center">
              <v-col cols="12" md="1" sm="6">
                <span class="label">{{ i18n.city }}</span>
                <br>
                <v-chip label x-small color="secondary" dark class="mt-1">{{ lead.city ? lead.city.name : null }}</v-chip>
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <span class="label">{{ i18n.business_name_english }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.business_name_english }}</span>
              </v-col>
              <v-col cols="12" md="2" sm="6">
                <span class="label">{{ i18n.mobile_no }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.mobile_no }}</span>
              </v-col>
              <v-col cols="12" md="2" sm="6">
                <span class="label">{{ i18n.phone_no }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.phone_no }}</span>
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <span class="label">{{ i18n.email }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.email }}</span>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="6" lg="3">
                <span class="label">{{ i18n.cbls_no }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.cbls_no }}</span>
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <span class="label">{{ i18n.is_branch }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.is_branch ? 'Yes' : 'No' }}</span>
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <span class="label">{{ i18n.est_date }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.est_date }}</span>
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <span class="label">{{ i18n.expiry_date }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.expiry_date }}</span>
              </v-col>
              <v-col cols="12" class="mx-auto text-center" md="4" sm="6">
                <span class="label">{{ i18n.economic_department }}</span>
                <br>
                <span class="mt-0 d-block">{{ lead.economic_department }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-for="category in lead.categories" :key="category.id" cols="12" md="6" lg="3">
                {{ category.name }}
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['leads'],
  methods: {
    leadCategories(lead) {
      return lead.categories.reduce((acc, curr) => {
        acc.push(curr.name)
        return acc
      }, []).join(", ")
    } 
  },
  computed: {
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
  }
}
</script>

<style scoped>

.label {
  font-size: 10px;
  font-weight: 600;
}

</style>